import React, { FC, useEffect, useCallback, useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import ClickAwayListener from '@mui/material/ClickAwayListener'
import useEditorActions from './useEditorActions'

import EditorContext from './EditorContext'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
}))

interface LayoutWrapperProps {}

const LayoutWrapper: FC<React.PropsWithChildren<LayoutWrapperProps>> = ({
  children,
}) => {

  const classes = useStyles()

  const {
    changeEvent,
    setChangeEvent,
    editorEvent,
    setEditorEvent,
    selectionLocked,
  } = useContext(EditorContext)

  const {
    deselect,
    processChangeEvent,
  } = useEditorActions()

  const onBlur = useCallback(() => {
    if(selectionLocked) return
    deselect()
  }, [
    selectionLocked,
    deselect,
  ])

  useEffect(() => {
    if(!changeEvent) {
      return
    }
    processChangeEvent()
    setChangeEvent(null)
  }, [
    changeEvent,
  ])

  useEffect(() => {
    if(!editorEvent) {
      return
    }
    setEditorEvent(null)
  }, [
    editorEvent,
  ])

  return (
    <ClickAwayListener onClickAway={ onBlur }>
      <div className={ classes.root }>
        { children }
      </div>
    </ClickAwayListener>
  )
}

export default LayoutWrapper
